import { render, staticRenderFns } from "./CalendarResources.vue?vue&type=template&id=25abb20e&scoped=true"
import script from "./CalendarResources.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalendarResources.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CalendarResources.vue?vue&type=style&index=0&id=25abb20e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25abb20e",
  null
  
)

export default component.exports